module.exports = __webpack_public_path__ + "img/bluesky3100_03.ba836601.jpg";